import { render, staticRenderFns } from "./product-inventory.vue?vue&type=template&id=5381d870&scoped=true&"
import script from "./product-inventory.vue?vue&type=script&lang=js&"
export * from "./product-inventory.vue?vue&type=script&lang=js&"
import style0 from "./product-inventory.vue?vue&type=style&index=0&id=5381d870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5381d870",
  null
  
)

export default component.exports